import barba from "@barba/core";
import gsap from "gsap";

class ProjectEvents {
  constructor() {
    this.currentPos = 0;
    this.speed = 0;
    this.animating = false;
    this.bottom = false;

    this.queryFreshBottom();
    this.raf();
    this.events();
    this.barba();
  }

  queryFreshBottom() {
    this.el = document.querySelector(".pbottom__text");
  }

  blockScroll() {}

  barba() {
    let that = this;
    this.barbaInstance = barba.init({
      transitions: [
        {
          name: "default-transition",
          sync: false,
          leave(data) {
            return gsap.fromTo(data.current.container,{
                opacity:1,
                y:0
            }, {
              opacity: 0,
              duration: 0.3,
              y: -100,
              onStart: () => {
                console.log("leave start");
                window.locoScroll.stop()
                that.bottom = false;
                that.animating = true;
                that.currentPos = 0;
                that.speed = 0;
              },
              onComplete: () => {
                console.log("leave complete");
                data.current.container.parentNode.removeChild(
                  data.current.container
                );
                window.locoScroll.scrollTo('top',{duration: 0,disableLerp: true})
              },
            });
          },
          enter(data) {
            return gsap.fromTo(
              data.next.container,
              {
                opacity: 0,
                y: 100
              },
              {
                opacity: 1,
                duration: 0.3,
                y: 0,
                onStart: () => {
                  console.log("enter start");
                  window.locoScroll.scrollTo('top',{duration: 0,disableLerp: true})
                },
                onComplete: () => {
                  console.log("enter complete");
                  that.queryFreshBottom();
                  that.animating = false
                  
                  
                },
              }
            );
          },
          after(){
            window.locoScroll.update();
            setTimeout(()=>{window.locoScroll.start();},300)


          }
        },
      ],
    });
  }

  events() {
    window.locoScroll.on("scroll", (event) => {
    //   console.log(event.delta,event.speed,event)
      if(Math.abs(event.scroll.y-event.limit.y)<10){
        this.bottom = true;
      } else{
        this.bottom = false;
      }
    });

    window.addEventListener("wheel", (e) => {
      if(this.bottom){
        this.speed = e.deltaY * 0.05;
        this.currentPos += this.speed;
      }
      
    });

    // document.querySelector('.ptop__title').addEventListener('click',()=>{
    //     console.warn('actually going with click')
    //     this.animating = true;
    //     barba.go('project.html')
    // })
  }

  raf() {
    // this.speed *= 0.5;
    this.currentPos *= 0.98;

    if(this.currentPos>150 &&  this.bottom){
        this.currentPos = 0;
        this.animating = true;
        barba.go(document.querySelector('.pbottom__text').getAttribute('href'))
    }
    if (!this.animating && this.bottom) {
      this.el.style.transform = `translate3d(0,${-this.currentPos}px,0)`;
    }

    // console.log(this.currentPos)
    window.requestAnimationFrame(this.raf.bind(this));
  }
}

if (document.querySelector(".ptop")) new ProjectEvents();
